import { makeStyles } from '@material-ui/core/styles';
import { BOGLE_REGULAR } from '../../constants/constant';
import { colors } from '../../theme/color-palette';

const {
	WHITE,
	LIGHT_GREY,
	PURPLE,
	BLACK,
	GREY,
	LIGHT_GRAY_SHADE,
	HOVER_GRAY_SHADE,
} = colors;
const insightsStyles = makeStyles((theme) => ({
	mainContainer: {
		background: WHITE,
		borderRadius: 16,
		boxShadow: '1px 1px 8px 0 rgb(0 0 0 / 10%)',
	},
	filterWrapper: {
		height: '68px',
		padding: '10px 0px 10px 10px',
		'@media (min-width:1440px)': {
			padding: '16px 30px 10px 30px',
		},
		'@media (max-width: 680px)': {
			height: '0 !important',
		},
	},
	filterContainer: {
		height: 56,
	},
	kpiCardContainer: {
		padding: '24px 16px',
	},
	trendChartContainer: {
		height: 412,
		padding: '24px 16px',
		marginTop: '24px',
	},
	bgcolory: {
		backgroundColor: 'yellow',
	},
	channelMixContainer: {
		height: '100%',
		backgroundColor: 'red',
	},
	trendChartHeading: {
		padding: '1em',
		textAlign: 'start',
	},
	trendChartSubHeading: {
		fontSize: '20px',
		lineHeight: '1.6',
	},
	pcChangeTab: {
		borderBottom: `4px solid ${LIGHT_GREY}`,
	},
	netSalesTab: {
		borderBottom: `4px solid ${PURPLE}`,
	},
	tab: {
		width: 57,
		height: 16,
		flexGrow: 0,
		fontSize: 14,
		lineHeight: 1.14,
		color: BLACK,
		paddingLeft: 10,
		paddingRight: 10,
	},
	mainFilter: {
		fontFamily: BOGLE_REGULAR,
		fontSize: 14,
		color: BLACK,
		fontWeight: 'normal',
		cursor: 'pointer',
		borderRadius: 100,
		textAlign: 'center',
		width: '58px',
		height: '27px',
		fontStyle: 'normal',
		lineHeight: '19px',
	},
	subFilter: {
		fontFamily: 'Bogle-Light',
		fontSize: 14,
		color: GREY,
		fontWeight: 300,
		cursor: 'pointer',
		borderRadius: 10,
	},
	active: {
		backgroundColor: WHITE,
		background: WHITE,
		boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
		borderRadius: 100,
		color: '#3C228A',
	},
	dividerMargin: {
		marginRight: '8px',
	},
	box: {
		display: 'flex',
		justifyContent: 'center',
	},
	channelBreakDownFilterFormat: {
		width: '58px',
		height: '27px',
		// boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
		// borderRadius: 100,
		// backgroundColor: WHITE,
		// background: WHITE,
	},
	filters: {
		maxWidth: 'unset',
		flexBasis: 'unset',
		padding: '4px 12px',
		marginRight: '8px',
	},

	select: {
		'& .MuiSvgIcon-root': {
			color: PURPLE,
		},

		'& .MuiSelect-select:focus': {
			backgroundColor: 'transparent',
		},
		'& .MuiSelect-select': {
			fontFamily: BOGLE_REGULAR,
		},
	},
	menuPaper: {
		maxHeight: '256px !important',
		boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.1)  !important',
		'&& .Mui-selected': {
			backgroundColor: LIGHT_GRAY_SHADE,
		},
		'&& .MuiMenuItem-root:hover': {
			backgroundColor: HOVER_GRAY_SHADE,
		},
	},
	formContol: {
		maxWidth: '400px',
		'@media (min-width:940px) and (max-width: 1440px)': {
			maxWidth: '300px',
		},
		'@media (min-width:1440px)': {
			maxWidth: '500px',
		},
	},
	rootSelect: {
		'@media (max-width:460px)': {
			width: '90vw',
		},
		'& MuiSelect-select': {
			'@media (max-width:460px)': {
				fontSize: '16px',
			},
			fontSize: '16px',
		},
	},
	rootMenuItem: {
		'@media (max-width:460px)': {
			width: '90vw',
			fontSize: '16px',
		},
		fontFamily: BOGLE_REGULAR,
	},
	button: {
		textTransform: 'unset',
		display: 'flex',
		width: '100%',
		justifyContent: 'flex-end',
		'&:hover': {
			background: 'none',
		},
	},
	buttonLabel: {
		fontSize: '14px',
		height: '22px',
		fontWeight: 400,
		color: PURPLE,
		fontFamily: 'Bogle-Medium',
		cursor: 'pointer',
	},
	weekFiltermenuPaper: {
		maxHeight: 'calc(100% - 96px)',
		boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.1)  !important',
		'&& .Mui-selected': {
			backgroundColor: LIGHT_GRAY_SHADE,
		},
		'&& .MuiMenuItem-root:hover': {
			backgroundColor: HOVER_GRAY_SHADE,
		},
	},
	weekFloat: {
		float: 'right',
		'@media (min-width: 360px) and (max-width: 850px)': {
			clear: 'both',
			marginRight: theme.spacing(2),
		},
	},
}));

export default insightsStyles;
